import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import makeStyles from '@mui/styles/makeStyles';
import ButtonBase from '@mui/material/ButtonBase';

import Typography from '@ts-core/components/Typography';

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(0.5),
    borderRadius: 4,
    marginLeft: -theme.spacing(0.5),
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  icon: {
    color: theme.palette.grey[500],
  },
  text: {
    color: theme.palette.grey[500],
    marginLeft: theme.spacing(1),
    fontSize: 13,
    fontWeight: 700,
  },
}));

const ThreadToolbarButton = (props) => {
  const classes = useStyles();

  const { Icon, title, onClick, disabled, className } = props;
  return (
    <ButtonBase
      className={classnames(className, classes.button)}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon className={classes.icon} />
      <Typography className={classes.text}>{title}</Typography>
    </ButtonBase>
  );
};

ThreadToolbarButton.propTypes = {
  Icon: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

ThreadToolbarButton.defaultProps = {
  className: undefined,
  onClick() {},
  disabled: false,
};

export default ThreadToolbarButton;
